import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import { getBankAccountQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getBankAccount/getBankAccountQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const ShowBankAccount = () => {
  const { id, damagedId } = useParams();
  const { data } = useQuery(
    getBankAccountQueryOptions({ id: +id!, damaged_id: +damagedId! }),
  );

  return (
    <Box
      className={css({
        paddingX: '16px',
        paddingTop: '24px',
        paddingBottom: '24px',
      })}
    >
      <ShowIncidentParticipantsDataCard
        data={[
          { label: 'بانک', value: data?.account_bank?.name! },
          { label: 'دارنده حساب', value: data?.account_owner_name! },
          { label: 'شماره کارت', value: data?.account_card_number! },
          { label: 'شماره شبا', value: data?.account_sheba_number! },
          { label: 'شماره حساب', value: data?.account_number! },
        ]}
        title="اطلاعات حساب بانکی"
      />
    </Box>
  );
};
export default ShowBankAccount;
